const scrollToId = (id) => {
  const access = document.getElementById(id)
  access.scrollIntoView({ behavior: 'smooth', block: 'center' }, true)
}

export default scrollToId
